import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/MockAuthContext';
import Navigation from './components/Navigation';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

// Lazy load pages for code splitting
const Homepage = lazy(() => import('./pages/Homepage'));
const WaterfallsByState = lazy(() => import('./pages/WaterfallsByState'));
const StateWaterfalls = lazy(() => import('./pages/StateWaterfalls'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Blog = lazy(() => import('./pages/Blog'));
const MockAdminDashboard = lazy(() => import('./pages/MockAdminDashboard'));
const NotFound = lazy(() => import('./pages/NotFound'));

const AppContainer = styled.div`
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 1.2rem;
  color: #74b9ff;
`;

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AppContainer>
          <Router>
            <AuthProvider>
              <Navigation />
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner>Loading...</LoadingSpinner>}>
                  <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/states" element={<WaterfallsByState />} />
                    <Route path="/waterfalls/:stateName" element={<StateWaterfalls />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/admin" element={<MockAdminDashboard />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </ErrorBoundary>
            </AuthProvider>
          </Router>
        </AppContainer>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
